import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import { difference } from 'lodash';
import { transferScheduleValidationSchema } from '../../validation/transferSchedule';
import TransferScheduleForm from '~/components/transferScheduleForm/transferScheduleForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getTransferScheduleQuery = gql`
  query transferSchedule($id: Int!) {
    transferSchedule(id: $id) {
      id
      name
      description
      isConsolidated
      transfers {
        id
        name
        stepNumber
        days
        locationId
        type
        tankType
        tankId
        vesselDescription
        notes
        requiresDutyPaid
        shouldAutocomplete
        nextTransferScheduleId
      }
    }
  }
`;

export const updateTransferSchedulesMutation = gql`
  mutation updateTransferSchedule(
    $id: Int!
    $name: String!
    $description: String
    $transfers: [TransferForScheduleUpdate]!
    $transferIdsToArchive: [Int]
  ) {
    updateTransferSchedule(
      id: $id
      name: $name
      description: $description
      transfers: $transfers
      transferIdsToArchive: $transferIdsToArchive
    ) {
      id
      name
    }
  }
`;

const convertFormValuesIntoUpdateShape = (initialValues, newValues) => {
  const returnValues = { ...newValues };
  // Ensure the stepNumbers are correct before saving
  returnValues.transfers = returnValues.transfers.map((transfer, idx) => {
    const trns = {
      ...transfer,
      tankId: transfer.type === 'TANK' && transfer.tankType === 'BRITE_TANK' ? transfer.tankId : null,
      stepNumber: idx + 1
    };
    delete trns.__typename;
    return trns;
  });

  // Find the ids that are in the initial values but not in the new values
  // These are for archiving
  const getId = t => t.id;
  returnValues.transferIdsToArchive = difference(
    initialValues.transfers.map(getId),
    newValues.transfers.map(getId)
  ).filter(t => !!t);

  return returnValues;
};

export class TransferScheduleEdit extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same silly update Apollo issue I keep running into
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;

    return (
      <Query
        query={getTransferScheduleQuery}
        variables={{ id }}
        onCompleted={onCompleted}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { transferSchedule } = data;
          return (
            <div className="content">
              <Mutation mutation={updateTransferSchedulesMutation}>
                {(updateTransferSchedule, { error }) => (
                  <Formik
                    initialValues={transferSchedule}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={transferScheduleValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await updateTransferSchedule({
                          variables: convertFormValuesIntoUpdateShape(transferSchedule, values)
                        });
                        history.push(`/settings/transfers/${id}?updated=true`);
                      } catch (err) {
                        console.log(err);
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={TransferScheduleForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(TransferScheduleEdit);



// WEBPACK FOOTER //
// ./src/containers/transferScheduleEdit/transferScheduleEdit.jsx